module.exports = __webpack_public_path__ + "img/permissions.d2f4caef.svg";